import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import ONS from './ONS'
import CNS from './CNS'
import MNS from './MNS'
import RNP from './RNP'
import HNP from './HNP'
import BNP from './BNP'
import SWITCHBOARDLOG from './LOG'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

export const SwitchBoardContainer = ({ actionPermits, envConfig }) => {
  const container = useMemo(
    _ => {
      return hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.SWITCHBOARD,
          ScreenPermissions.SWITCHBOARD_IMPORT,
        ],
        matchAny: true,
      }) ? (
        [
          <Route exact path="/bnp" key="bnproute" component={BNP} />,
          <Route exact path="/cns" key="cnsroute" component={CNS} />,
          <Route exact path="/hnp" key="hnproute" component={HNP} />,
          <Route exact path="/mns" key="mnsroute" component={MNS} />,
          <Route exact path="/ons" key="onsroute" component={ONS} />,
          <Route exact path="/rnp" key="rnproute" component={RNP} />,
          <Route
            exact
            path="/switchboardlog"
            key="switchboardlog"
            component={SWITCHBOARDLOG}
          />,
        ]
      ) : (
        <React.Fragment />
      )
    },
    [actionPermits, envConfig.authGodMode]
  )
  return container
}
